<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.push('/main')" />

                <div class="all-profiles-view">
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('profileSelectingPage.profilesHeader') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div v-if="!deleteFlag" class="all-profiles-view__content">
                        <uzhnet-button class="w-92 add-profile-button" @click="$router.push('/add-new-account')" :label="$t('allProfilesPage.addProfileButton')" />

                        <div class="all-profiles">
                            <div v-for="profile in allProfiles" class="profile-row">
                                <div class="profile-row__content">
                                    <div class="profile-row__icon">
                                        <div class="menu-container__button">
                                            <img src="@/assets/icons/specials/profile-icon.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="profile-row__data">
                                        <div>{{ profile.login }}</div>
                                        <div class="truncate">{{ locale == 'en' ? transliterate(profile.address) : profile.address}}</div>
                                    </div>
                                </div>
                                <div class="profile-row__select">
                                    <img @click="deleteProfile(profile.login)" src="@/assets/images/delete-button.svg" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="profile-delete-button">
                            <uzhnet-button-danger class="w-92 delete-profile-button" @click="deleteProfile(selectedProfileId)" :label="$t('allProfilesPage.exit')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import '@/assets/scss/all-profiles-page.scss';

import { ref, onMounted } from 'vue';
import { useMainStore } from '@/store/mainStore';
import { useRouter } from 'vue-router';

import { getAccounts } from '@/db/accountService';

import { useI18n } from 'vue-i18n';

function transliterate(text) {
    const ukToEnMap = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D',
        'Е': 'E', 'Є': 'Ye', 'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I',
        'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
        'Ь': '', 'Ю': 'Yu', 'Я': 'Ya',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
        'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
        'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
        'ь': '\'', 'ю': 'iu', 'я': 'ia'
    };

    if (text) {
        return text.split('').map(char => ukToEnMap[char] || char).join('');
    } else {
        return text
    }
}

export default {
    name: "AllProfilesView",

    setup() {
        const store = useMainStore()
        const router = useRouter()

        const selectedProfileId = ref(0);

        const allProfiles = ref([]);

        const { locale } = useI18n();

        onMounted(async () => {
            const allAccountsCursor = await getAccounts();
            allProfiles.value = allAccountsCursor.map(account => {
                return account._data
            })

            selectedProfileId.value = store.login
        })

        const deleteProfile = (profile) => {
            store.setProfileForDeletion(profile);
            const profileAddress = allProfiles.value.find(profile => profile.login === store.profile_for_deletion).address;
            store.setProfileForDeletionAddress(profileAddress);

            router.push('/delete-profile');
        }

        return {
            deleteProfile,
            selectedProfileId,
            allProfiles,

            transliterate: transliterate,
            locale
        }
    }
}
</script>
